const historical = (root: string) => () => `${root}/historical`;

const legacy = (root: string) => () => `${root}/legacy`;

export const reportsRoutes = (root: string) => ({
  root,
  historical: historical(root),
  legacy: legacy(root),
});
